var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 22,
    viewBox: "0 0 14 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.75 21.5L0 10.75L10.75 0L13.2583 2.50833L5.01667 10.75L13.2583 18.9917L10.75 21.5Z",
    fill: "#232323"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/back-arrow.6b14373a03efe733f30e30e4d3a2d315.svg";
export { ForwardRef as ReactComponent };